import { Link } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { Alert, Card, DataTable, Empty, ErrorBox, Loading, PageHeader, Reg } from "../ui";
import { useIsOwner } from "../auth";
import { BookingStatusBadge, DeptBadge, date } from "../format";
import { formatGBP } from "../../shared/money";

export default function Dashboard() {
  const q = useQuery({ queryKey: ["dashboard"], queryFn: () => api.get("/dashboard"), refetchInterval: 60_000 });
  const owner = useIsOwner();
  const twoStep = useQuery({ queryKey: ["two-step"], queryFn: () => api.get("/me/two-step"), enabled: owner });
  if (q.isLoading) return <Loading />;
  if (q.isError) return <ErrorBox error={q.error} retry={() => q.refetch()} />;
  const d = q.data;
  return (
    <>
      <PageHeader title="Dashboard" sub={`Today is ${date(d.today)} · figures update every minute`}
        actions={<><Link className="btn btn-secondary" to="/enquiries?new=1">Log enquiry</Link><Link className="btn btn-primary" to="/jobs/new">New job</Link></>} />
      {owner && twoStep.data?.available && !twoStep.data.enabled && <div style={{ marginBottom: 12 }}><Alert kind="warn" title="Protect the owner account">Turn on two-step sign-in so a stolen password alone cannot open the accounts. <Link to="/settings">Settings → My account</Link></Alert></div>}
      <div className="tiles">
        {d.tiles.map((t: any) => (
          <Link key={t.key} to={t.link} className={`tile ${t.format === "money" ? "money" : ""} ${t.key === "unpaid" && t.value > 0 ? "alert" : ""}`} title={t.basis}>
            <div className="label">{t.label}</div>
            <div className="value">{t.format === "money" ? formatGBP(t.value) : t.value}</div>
            {t.count !== undefined && <div className="small muted">{t.count} invoice{t.count === 1 ? "" : "s"}</div>}
            <div className="basis">{t.basis}</div>
          </Link>
        ))}
      </div>
      <Card title="Today's bookings" actions={<Link to="/bookings" className="btn btn-sm btn-secondary">Open calendar</Link>} pad={false}>
        <DataTable rows={d.todaysBookings} rowLink={(b: any) => `/bookings?date=${d.today}&open=${b.id}`}
          empty={<Empty title="No bookings today">Bookings for today will appear here.</Empty>}
          columns={[
            { key: "t", label: "Time", render: (b: any) => b.start_time ?? "Any time" },
            { key: "c", label: "Customer", render: (b: any) => b.customer_name ?? <span className="muted">Not linked</span> },
            { key: "r", label: "Vehicle", render: (b: any) => <Reg reg={b.registration} /> },
            { key: "d", label: "Dept", render: (b: any) => <DeptBadge d={b.department} /> },
            { key: "w", label: "Work", render: (b: any) => b.description ?? "" },
            { key: "s", label: "Status", render: (b: any) => <BookingStatusBadge s={b.status} /> },
          ]} />
      </Card>
    </>
  );
}
